import React from 'react';
import { connect } from 'react-redux';
import ChatSection from './ChatSection';
import ReviewSection from '../feedbackdetail/ReviewSection';
import ActionSection from './ActionSection';
import FeedbackSection from '../feedbackdetail/FeedbackSection';
import NoteSection from '../feedbackdetail/NoteSection';
import AttachmentSection from '../feedbackdetail/AttachmentSection';
import AdminAttachmentSection from '../feedbackdetail/AdminAttachmentSection';
import TagsSection from '../feedbackdetail/TagsSection';
import { getRequestedVia, getStarsJSX, getChatStatus, getAttachmentsUrls, genEmailButton } from '../redux/FeedbackRedux';
import Loading from './Loading';
import Alert from '../Alert'
import DateFormatter from '../Classes/DateFormatter'

class FeedbackDetail extends React.Component {
    constructor(props) {
        super(props);
    }

    handleBackClick() {
        const $body = jQuery('body');
        if ($body.width() <= 1000) {
            if ($body.find('.feedback-detail-scroll').hasClass('is-hidden-mobile')) {
                $body.find('.feedback-list').addClass('is-hidden-mobile');
                $body.find('.dashboard-stats').addClass('is-hidden-mobile');
                $body.find('.feedback-detail-scroll').removeClass('is-hidden-mobile');
            } else if ($body.find('.feedback-list').hasClass('is-hidden-mobile')) {
                $body.find('.feedback-detail-scroll').addClass('is-hidden-mobile');
                $body.find('.feedback-list').removeClass('is-hidden-mobile');
                $body.find('.dashboard-stats').removeClass('is-hidden-mobile');
            }
        }
    }

    componentDidMount() {
        $('[data-toggle="tooltip"], [data-toggle-second="tooltip"]').each(function () {
            jQuery(this).tooltip({ html: true, placement: 'bottom',
                container: 'body',
                boundary: 'window'
            });
        });

        $('[data-toggle="tooltip"], [data-toggle-second="tooltip"]').each(function () {
            var title = jQuery(this).attr('data-original-title');
            jQuery(this).attr('title', title);
        });

    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        $('[data-toggle="tooltip"], [data-toggle-second="tooltip"]').each(function () {
            jQuery(this).tooltip({ html: true, placement: 'bottom',
                container: 'body',
                boundary: 'window'
            });
        });

        $('[data-toggle="tooltip"], [data-toggle-second="tooltip"]').each(function () {
            var title = jQuery(this).attr('data-original-title');
            jQuery(this).attr('title', title);
        });

        if (
            this.props.state.filterFeedbacksCount !== prevProps.state.filterFeedbacksCount
        ) {
            const open = document.querySelector('.sidebar-feedback-history-status-open');
            if (open && this.props.state.filterFeedbacksCount.feedbackCountDetails.countOpen !== undefined) {
                open.innerHTML = this.props.state.filterFeedbacksCount.feedbackCountDetails.countOpen;
                open.classList.remove('hidden');
                if (this.props.state.filterFeedbacksCount.hasPriorities &&
                    this.props.state.filterFeedbacksCount.hasPriorities.Open &&
                    this.props.state.filterFeedbacksCount.hasPriorities.Open[30]) {
                    open.classList.add('anim-pulse-side-bar'); // intentional pulse only for priority 30 (red/high)
                } else {
                    open.classList.remove('anim-pulse-side-bar');
                }
            }

            const pending = document.querySelector('.sidebar-feedback-history-status-pending');
            if (pending && this.props.state.filterFeedbacksCount.feedbackCountDetails.countPending !== undefined) {
                pending.innerHTML = this.props.state.filterFeedbacksCount.feedbackCountDetails.countPending;
                pending.classList.remove('hidden');
                if (this.props.state.filterFeedbacksCount.feedbackCountDetails.countPending > 0 ) {
                    pending.classList.add('anim-pulse-side-bar'); // intentional pulse for any priority
                } else {
                    pending.classList.remove('anim-pulse-side-bar');
                }
            }

            const resolved = document.querySelector('.sidebar-feedback-history-status-resolved');
            if (resolved && this.props.state.filterFeedbacksCount.feedbackCountDetails.countResolved !== undefined) {
                resolved.innerHTML = this.props.state.filterFeedbacksCount.feedbackCountDetails.countResolved;
                resolved.classList.remove('hidden');
            }

            const all = document.querySelector('.sidebar-feedback-history-status-all');
            if (all && this.props.state.filterFeedbacksCount.feedbackCountDetails.countAll !== undefined) {
                all.innerHTML = this.props.state.filterFeedbacksCount.feedbackCountDetails.countAll;
                all.classList.remove('hidden');
            }
            const RatingsOnly = document.querySelector('.sidebar-feedback-history-status-neg-rating-no-fb');
            if (RatingsOnly && this.props.state.filterFeedbacksCount.feedbackCountDetails.countRatingsOnly !== undefined) {
                RatingsOnly.innerHTML = this.props.state.filterFeedbacksCount.feedbackCountDetails.countAll;
                RatingsOnly.classList.remove('hidden');
            }
        }
    }

    render() {
        const attachments = getAttachmentsUrls(this.props.feedback);
        var moment = require('moment-timezone');
        var response_via_text = getRequestedVia(this.props.feedback);
        const { chat_alert, chat_button_text } = getChatStatus(this.props.feedback);
        const stars = getStarsJSX(this.props.feedback.ratethisbizrating ? this.props.feedback.ratethisbizrating.rating : null);
        var email_forward = genEmailButton(this.props.feedback, 'dropdown-item text-primary');

        var tags = false;
        for (var i in this.props.feedback.business.tags) {
            if (this.props.feedback.business.tags[i].is_active) {
                tags = true;
                break;
            }
        }

        var archive_button = <a href="#" onClick={this.handleArchiveClick} className="btn btn-sm btn-outline-danger d-inline-block archive-button text-capitalize"><i className="far fa-archive mr-1"></i> { __('Archive') }</a>;
        if (this.props.feedback.is_archived) {
            archive_button = <a href="#" onClick={this.handleArchiveClick} className="btn btn-sm btn-warning d-inline-block archive-button text-capitalize"><i className="far fa-archive mr-1"></i> { __('Unarchive') }</a>;
        }

        let main_classes = "col-12 px-2";

        const formattedTime = DateFormatter.formatUtcDate(new Date(this.props.feedback.created_at), this.props.state.business.call_at_timezone, this.props.state.app_locale);
        let dow = (this.props.feedback.dow !== "" ? this.props.feedback.dow + ", " : "") + formattedTime;

        return (
            <div className={main_classes} id={this.props.center ? "center-detail" : null}>
                <Loading location={'feedbackSection'} />
                {!this.props.state.hide_initial_feedbacks &&
                    <button className="btn btn-sm btn-primary d-none mb-3" onClick={this.handleBackClick.bind(this)}><i className="fas fa-arrow-circle-left mr-1"></i> { __('Back') }</button>
                }

                <div className="d-flex justify-content-center">
                    <div className="mt-2" style={{width: "60%"}}>
                        <Alert alert={this.props.state.alert.alert} location={'feedback_detail'}/>
                    </div>
                </div>
                {/* <StatusSection feedback={this.props.feedback} current_user={this.props.current_user} /> */}
                <div className={'d-block d-xl-none feedback-details-wrapper'}>
                    {!this.props.showChat ?
                        <>
                            <div className={'feedback-details-wrapper-section feedback-details-wrapper-section--pt110 '}>
                                <FeedbackSection feedback={this.props.feedback} current_user={this.props.current_user}
                                                 dispatch={this.props.dispatch}/>

                                {/* time section */}
                                <div className={'d-block d-xl-none'}>
                                    <span className="d-block d-xl-none">{dow}</span>
                                </div>

                            </div>
                            <div className={'feedback-details-wrapper-section'}>
                                <ActionSection/>
                            </div>
                            <div className={'feedback-details-wrapper-section'}>
                                <ReviewSection feedback={this.props.feedback} current_user={this.props.current_user}/>
                            </div>
                            <div className={'feedback-details-wrapper-section'} data-showonprint={this.props?.feedback?.notes?.length > 0}>
                                <NoteSection feedback={this.props.feedback} user_id={this.props.current_user}
                                             ref={this._notesection} current_user={this.props.current_user}/>
                            </div>

                            {attachments?.length > 0 &&
                                <div className={'feedback-details-wrapper-section'}>
                                    <AttachmentSection attachments={attachments} feedback={this.props.feedback} current_user={this.props.current_user} />
                                </div>
                            }

                            {this.props.current_user && tags ?
                                <div className={'feedback-details-wrapper-section'} data-showonprint={this.props?.feedback?.feedback_tags?.length > 0}>
                                    <TagsSection feedback={this.props.feedback} current_user={this.props.current_user}/>
                                </div> : null
                            }

                            <div className={'feedback-details-wrapper-section feedback-details-wrapper-section-last'}
                                 data-showonprint={
                                    this.props?.feedback?.feedback_attachments?.length > 0 &&
                                    !this.props.feedback.feedback_attachments.every(
                                        (att) => att.type === 'feedback_attachment_ext'
                                )}
                            >
                                <AdminAttachmentSection feedback={this.props.feedback}
                                                        current_user={this.props.current_user}/>
                            </div>
                            <div className={'feedback-details-chat-icon'} onClick={this.props.toggleChat}>
                                <img src="/img/chat-icon.svg" alt={'Chat Icon'}/>
                            </div>
                        </> : <div className={'chat-section-m'}>
                            <div className={'wrapper d-flex'}>
                                <div className="chat-close-icon" onClick={this.props.toggleChat}>&#x2715;</div>
                                <ChatSection feedback={this.props.feedback} current_user={this.props.current_user}
                                             dispatch={this.props.dispatch} />
                            </div>
                        </div>}

                    {/* show chat for print */}
                    <div className={'chat-section-m chat-section--print'}>
                        <div className={'wrapper d-flex'}>
                            <div className="chat-close-icon" onClick={this.props.toggleChat}>&#x2715;</div>
                            <ChatSection feedback={this.props.feedback} current_user={this.props.current_user}
                                         dispatch={this.props.dispatch} />
                        </div>
                    </div>
                </div>
                <div className="card feedback-detail mt-2 d-none d-xl-block">
                    <div className="row">
                        {/* Actions Bar*/}
                        <div className="col-12">
                            <ActionSection />
                        </div>

                        {/* Feedback Details */}
                        <div className="col-8 pr-0 feedback-detail-left-section">
                            <FeedbackSection feedback={this.props.feedback} current_user={this.props.current_user} dispatch={this.props.dispatch} />
                            <NoteSection feedback={this.props.feedback} user_id={this.props.current_user} ref={this._notesection} current_user={this.props.current_user} />
                            <AttachmentSection attachments={attachments} feedback={this.props.feedback} current_user={this.props.current_user} />
                            {this.props.current_user && tags ? <TagsSection feedback={this.props.feedback} current_user={this.props.current_user} /> : null}
                            <AdminAttachmentSection feedback={this.props.feedback} current_user={this.props.current_user} />
                        </div>
                        <div className="col-4 pl-0 border-left">
                            <ChatSection feedback={this.props.feedback} current_user={this.props.current_user} dispatch={this.props.dispatch} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        feedback: state.feedback_detail,
        current_user: state.current_user,
        state: state
    }
}

export default connect(mapStateToProps)(FeedbackDetail)
